import Page from "../Common/Page";
import React from "react";
import { Form, Input, Row, Col, message, Modal } from "antd";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import withRouterDom from "../Common/WithReactRouterDom";
import { Link, NavigateFunction, Params } from "react-router-dom";
import { AuthorityButton } from "../Components/AuthorityButton";
import { ResultBean } from "../Common/Utils";
import { Messages } from "../Common/ValidateMessages";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { TextArea } = Input;
const { confirm } = Modal;

interface PostData {
  id: string;
  title: string;
  contents: string;
}
interface Props {
  navigation: NavigateFunction;
  params: Readonly<Params<string>>;
}
interface QuestionNameCheckRequestBean {
  questionId: string | undefined;
  questionName: string;
}

class QuestionRegist extends React.Component<Props> {
  static contextType = AuthContext;
  state = {
    // resultDisplay: "none",
    inputDisplay: "",
    completeDisplay: "none",
    // resultMsg: "",
    question: [
      { name: ["id"], value: "" },
      { name: ["title"], value: "" },
      { name: ["contents"], value: "" },
    ],
  };
  private _page: React.RefObject<Page>;

  constructor(props) {
    super(props);
    this._page = React.createRef<Page>();
  }

  async componentDidMount() {
    // this._page.current?.setState({ isPageLoading: true });
    // await new Promise((f) => setTimeout(f, 1000));
    const { params } = this.props;
    if (params.questionId !== undefined) {
      try {
        this._page.current?.setState({ isPageLoading: true });
        const result = await http<PostData>({
          path: "/Question/" + params.questionId,
          method: "get",
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          this.setState({
            question: [
              { name: "id", value: params.questionId },
              { name: "title", value: result.body?.title },
              { name: "contents", value: result.body?.contents },
            ],
          });
        } else {
          // this.setState({ resultDisplay: "" });
          // this.setState({ resultMsg: "指定した問題が存在しません。" });
          message.error(Messages["ERR-077"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        this._page.current?.setState({ isPageLoading: false });
        // this.setState({ resultDisplay: "" });
        // this.setState({ resultMsg: "指定した問題が存在しません。" });
        message.error(Messages["ERR-077"]);
      }
    }
  }

  submitForm = async (data: PostData) => {
    // this.setState({ resultDisplay: "none" });
    confirm({
      title: Messages["CON-028"],
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        this.doSave(data);
      },
      onCancel: () => {},
      okText: "はい",
      cancelText: "いいえ",
    });
  };

  doSave = async (data: PostData) => {
    this._page.current?.setState({ isPageLoading: true });

    try {
      const result = await http<undefined, PostData>({
        path: "/Question/regist",
        method: "post",
        body: { id: data.id, title: data.title, contents: data.contents },
        accessToken: this.context.accessToken,
        noResponsebody: true,
      });
      if (result.ok) {
        // this.setState({ resultDisplay: "none" });
        this.setState({ inputDisplay: "none" });
        this.setState({ completeDisplay: "" });
        // this.setState({ resultMsg: "" });
      } else {
        // this.setState({ resultDisplay: "" });
        this.setState({ inputDisplay: "" });
        this.setState({ completeDisplay: "none" });
        // this.setState({ resultMsg: "問題登録は失敗しました。" });
        message.error(Messages["ERR-078"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      // this.setState({ resultDisplay: "" });
      this.setState({ inputDisplay: "" });
      this.setState({ completeDisplay: "none" });
      // this.setState({ resultMsg: "問題登録は失敗しました。" });
      message.error(Messages["ERR-078"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {
    this.setState({ resultDisplay: "none" });
  };
  onChange = (newFields) => {
    this.setState({
      question: newFields,
    });
  };

  validatorCheckQuestionNameExist = async (
    _: any,
    value: string
  ): Promise<void> => {
    const { params } = this.props;
    try {
      if (value === undefined || value == null || value === "")
        return Promise.resolve();

      const postData: QuestionNameCheckRequestBean = {
        questionId: params.questionId,
        questionName: value,
      };
      const result = await http<ResultBean, QuestionNameCheckRequestBean>({
        path: "/Question/check/name",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 存在する
        return Promise.reject(new Error(Messages["ERR-056"]));
      } else {
        return Promise.resolve();
      }
    } catch (error) {
      // エラー
      console.log(error);
      message.error(Messages["ERR-020"]);
      // this.setState({ resultDisplay: "" });
      this.setState({ inputDisplay: "" });
      this.setState({ completeDisplay: "none" });
      // this.setState({ resultMsg: errorMsg });
    }
  };

  render() {
    return (
      <Page title="問題登録" ref={this._page}>
        <div
          className="data_content"
          style={{ padding: "20px", display: this.state.inputDisplay }}
        >
          {/* <Row style={{ display: this.state.resultDisplay }}>
            <Col span={12}>
              <Alert
                type={"error"}
                description={this.state.resultMsg}
                message={"エラー"}
                closable
              />
            </Col>
          </Row> */}
          <Row>
            <Col span={12}>
              <Form
                name="QuestionRegist"
                layout="vertical"
                onFinish={this.submitForm}
                onValuesChange={this.onFormValueChange}
                autoComplete="off"
                onFieldsChange={(_, allFields) => {
                  this.onChange(allFields);
                }}
                fields={this.state.question}
              >
                <Form.Item name="id">
                  <Input type={"hidden"} />
                </Form.Item>
                <Form.Item
                  name="title"
                  label="問題名"
                  validateTrigger={["onChange", "onFocus", "onBlur"]}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      validateTrigger: ["onChange"],
                    },
                    {
                      validator: this.validatorCheckQuestionNameExist,
                      validateTrigger: ["onFocus", "onBlur"],
                    },
                  ]}
                >
                  <Input placeholder="問題名" maxLength={30} />
                </Form.Item>
                <Form.Item
                  name="contents"
                  label="内容"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                    },
                  ]}
                >
                  <TextArea rows={8} placeholder="内容" maxLength={2000} />
                </Form.Item>
                <br />
                <Form.Item>
                  <AuthorityButton
                    type="primary"
                    size="middle"
                    htmlType="submit"
                  >
                    保存
                  </AuthorityButton>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
        <div
          className="data_content"
          style={{
            padding: "20px",
            display: this.state.completeDisplay,
            fontSize: "16px",
          }}
        >
          <Row>
            <Col span={6}>問題を登録しました。</Col>
          </Row>
          <br />
          <Row>
            <Col span={6}>
              <Link to={"/QuestionList"}>問題一覧へ</Link>
            </Col>
          </Row>
        </div>
      </Page>
    );
  }
}

export default withRouterDom(QuestionRegist);
